import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { ViewTitle } from '../../components/ViewTitle';
import { BackButton } from '../../components/Button';
import {  MaintenanceTypesForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';

export default function EditMaintenanceType({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const maintenanceTypes = useSelector((state) => state.maintenanceTypes);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: maintenanceTypes.name,
    },
  });

  useEffect(() => {
    dispatch(actions.maintenanceTypeGet(id));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      await dispatch(actions.maintenanceTypePut(id, data));
      await dispatch(actions.maintenanceTypeGet(id));
      alert('สำเร็จ');
    } catch (error) {
      console.log(error);
    }
  };
  if (maintenanceTypes.isLoading || maintenanceTypes.rows) {
    return <Loading />;
  }
  if (!maintenanceTypes.isLoading && maintenanceTypes.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <MaintenanceTypesForm
                errors={errors}
                maintenanceTypes={maintenanceTypes}
                control={control}
                Controller={Controller}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}
EditMaintenanceType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditMaintenanceType.defaultProps = {
  title: '',
  subtitle: '',
};
